import { openMenu } from "../service/headerService";

export default function toggle(toggleFn, state, externalUrl) {
  //  to close previous menu
  if (!(openMenu.toggleFn === null && openMenu.state === null)) {
    openMenu.toggleFn(!openMenu.state);
    // to close menu of same type
    if (openMenu.toggleFn === toggleFn) {
      openMenu.toggleFn = null;
      openMenu.state = null;
      return;
    }
  }
  // to open current menu
  if (externalUrl !== undefined || toggleFn !== openMenu.toggleFn) {
    if (externalUrl === undefined && toggleFn !== openMenu.toggleFn) {
      toggleFn(state);
      openMenu.toggleFn = toggleFn;
      openMenu.state = state;
      return;
    }
  }
}
